import { createAsyncThunk } from "@reduxjs/toolkit";
import endpointMaker from "configuration/endpoints";
import request from "http/request";

export const archiveCampaign = createAsyncThunk(
  "campaigns/archiveCampaign",
  async ({ campaignId }: { campaignId: string; onError?: any }, thunkAPI) => {
    const state: any = thunkAPI.getState();
    const { organizationId, accountId } = state.auth;

    return request
      .get(endpointMaker.api.archiveCampaign(organizationId, accountId, campaignId))
      .then(() => campaignId);
  }
);

export const unarchiveCampaign = createAsyncThunk(
  "campaigns/unarchiveCampaign",
  async (campaignId: string, thunkAPI) => {
    const state: any = thunkAPI.getState();
    const { organizationId, accountId } = state.auth;

    return request
      .get(endpointMaker.api.unarchiveCampaign(organizationId, accountId, campaignId))
      .then(() => campaignId);
  }
);
